// Dashboard.jsx
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Portal, Box, useDisclosure } from '@chakra-ui/react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Sidebar from 'components/sidebar/Sidebar';
import Navbar from 'components/navbar/NavbarAdmin';
import Footer from 'components/footer/FooterAdmin';
import { SidebarContext } from 'contexts/SidebarContext';
import routes from 'routes.js';

export default function Dashboard(props) {
  const { ...rest } = props;
  const location = useLocation(); // track route changes
  const { onOpen } = useDisclosure();

  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);

  // ------------------------------
  // Safety recursive functions
  // ------------------------------
  const getActiveRoute = (routesList) => {
    if (!routesList || !routesList.length) return "Dashboard";
    for (let i = 0; i < routesList.length; i++) {
      const route = routesList[i];
      if (route.collapse && route.items) {
        const collapseActive = getActiveRoute(route.items);
        if (collapseActive !== "Dashboard") return collapseActive;
      } else if (route.category && route.items) {
        const categoryActive = getActiveRoute(route.items);
        if (categoryActive !== "Dashboard") return categoryActive;
      } else if (route.layout && route.path) {
        if (location.pathname === route.layout + route.path) {
          return route.name;
        }
      }
    }
    return "Dashboard";
  };

  const getActiveNavbar = (routesList) => {
    if (!routesList || !routesList.length) return false;
    for (let i = 0; i < routesList.length; i++) {
      const route = routesList[i];
      if (route.collapse && route.items) {
        const collapseActive = getActiveNavbar(route.items);
        if (collapseActive !== false) return collapseActive;
      } else if (route.category && route.items) {
        const categoryActive = getActiveNavbar(route.items);
        if (categoryActive !== false) return categoryActive;
      } else if (route.layout && route.path) {
        if (location.pathname === route.layout + route.path) {
          return route.secondary || false;
        }
      }
    }
    return false;
  };

  const getActiveNavbarText = (routesList) => {
    if (!routesList || !routesList.length) return false;
    for (let i = 0; i < routesList.length; i++) {
      const route = routesList[i];
      if (route.collapse && route.items) {
        const collapseActive = getActiveNavbarText(route.items);
        if (collapseActive !== false) return collapseActive;
      } else if (route.category && route.items) {
        const categoryActive = getActiveNavbarText(route.items);
        if (categoryActive !== false) return collapseActive;
      } else if (route.layout && route.path) {
        if (location.pathname === route.layout + route.path) {
          return route.messageNavbar || false;
        }
      }
    }
    return false;
  };

  // ------------------------------
  // Generate Route components
  // ------------------------------
  const getRoutes = (routesList) => {
    if (!routesList || !routesList.length) return null;
    return routesList.map((route, key) => {
      if (route.layout === '/admin' && route.component) {
        return <Route path={route.path} element={route.component} key={key} />;
      }
      if (route.collapse && route.items) {
        return getRoutes(route.items);
      }
      return null;
    });
  };

  const getRoute = () => location.pathname !== '/admin/full-screen-maps';

  // ------------------------------
  // Render
  // ------------------------------
  return (
    <Box>
      <SidebarContext.Provider value={{ toggleSidebar, setToggleSidebar }}>
        <Sidebar routes={routes} display="none" {...rest} />
        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
          maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
        >
          <Portal>
            <Navbar
              onOpen={onOpen}
              logoText="Horizon UI Dashboard PRO"
              brandText={getActiveRoute(routes)}
              secondary={getActiveNavbar(routes)}
              message={getActiveNavbarText(routes)}
              fixed={fixed}
              {...rest}
            />
          </Portal>

          {getRoute() && (
            <Box
              mx="auto"
              p={{ base: '20px', md: '30px' }}
              pe="20px"
              minH="100vh"
              pt="50px"
            >
              <Routes>
                {getRoutes(routes)}
                <Route path="/" element={<Navigate to="/admin/default" replace />} />
              </Routes>
            </Box>
          )}

          <Footer />
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}